import PhoneInput from "react-phone-input-2";
import 'react-phone-input-2/lib/style.css'

export const InputPhone = ({...rest}) => {
    return (
        <>
            <PhoneInput
                inputStyle={{
                    width: '100%'
                }}
                containerClass={'input_phone'}
                inputClass={'input'}
                country={'ua'}
                isValid={(value, country) => {
                    if (value.match(/12345/)) {
                        return 'Invalid value: '+value+', '+country.name;
                    } else return !value.match(/1234/);
                }}
                {...rest}
            />
        </>
    );
}